module.exports = __webpack_public_path__ + "static/media/Group 16.a86d3be5.png";